<script>
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import fileTemplateState from "../../../stores/fileTemplateJsonData"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../../Script/queryString"
  import notify from "../../../../../../Script/notify"
  import axios from "axios"
  import { patchRequest } from "../../../../../../Script/apiMethods"
  /**
   * @type {String} -  Represents a query string or search parameter.
   */
  let query
  /**
   * @type {Boolean} - Indicating whether the save button should be disabled or not
   */
  let disableSaveBtn = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * Navigates back to the list page.
   */
  const backToListPage = () => {
    if (!$fileTemplateState.baseImageInfo.name) {
      const info = "PAGE: File template editor\nEVENT: While leaving file template editor"
      notify.danger("File template name can't be empty", info)
      return
    }
    $fileTemplateState.documentTemplateId = undefined
    goInitialState() //Call the goInitialState function.
    push("/templates/file")
  }

  // save the file template for particular id
  /**
   * Saves the overall file template by sending a PATCH request to the server.
   */
  const overAllTempSave = async () => {
    try {
      if (!$fileTemplateState.baseImageInfo.name) throw "File template name can't be empty"
      $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
        if (opp.errorX || opp.errorY) throw `Fix the layers marked with Exclamation icon as they are out of bounds.`

        return opp
      })
      if (!$fileTemplateState.operations.length) throw "Please add at least one layer."

      let isReceiverNameFound = Boolean($fileTemplateState.operations.filter((item) => item.attribute == "receiver_name").length)

      if (!isReceiverNameFound) throw 'The layer named "receiver_name" is missing, and it is mandatory. Please add the "receiver_name" layer'

      await loadFontList() // Call the loadFontList function asynchronously
      for (let i = 0; i < $fileTemplateState.operations.length; i++) {
        if ($fileTemplateState.operations[i].type == "image") {
          if ($fileTemplateState.operations[i].dynamic) {
            $fileTemplateState.operations[i].src = ""
          } else {
            if (!$fileTemplateState.operations[i].src.startsWith("/ipfs/")) $fileTemplateState.operations[i].src = ""
          }
        }
      }
      disableSaveBtn = true // Disable the save button

      let updatedFileTemp = {
        name: $fileTemplateState.baseImageInfo.name,
        document: $fileTemplateState.documentTemplateId,
        quality: $fileTemplateState.baseImageInfo.Quality,
        fonts: JSON.stringify($fileTemplateState.fonts),
        layers: JSON.stringify($fileTemplateState.operations),
      }
      query = queryStringToJSON($querystring)

      const { template } = await patchRequest(`/api/swagger/v2/templates/files/${$fileTemplateState.baseImageInfo.id}`, updatedFileTemp, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      goInitialState() // Call the goInitialState function
      $fileTemplateState.goBack = false
      notify.success(`File Design Template <strong style="hyphens: auto;">${template.name}<strong/> saved successfully`) // Show a success notification

      push("/templates/file") // Redirect to the file templates page
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor\nEVENT: While updating file template"
      closeNotification = notify.danger(error, info)
    } finally {
      disableSaveBtn = false // Redirect to the file templates page
    }
  }

  /**
   * Loads the list of fonts by sending a GET request to the server.
   * Updates the font list in the file template state.
   */
  const loadFontList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get("/api/swagger/v2/fonts", {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Error checking while API call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        let fontList = [...data.fonts]

        $fileTemplateState.fonts = []

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          if ($fileTemplateState.operations[i].type == "text") {
            for (let j = 0; j < fontList.length; j++) {
              if (fontList[j].name == $fileTemplateState.operations[i].fontFamily) {
                $fileTemplateState.fonts = [...$fileTemplateState.fonts, fontList[j].id]
              }
            }
          }
        }
        $fileTemplateState.fonts = [...new Set($fileTemplateState.fonts)]
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const goInitialState = () => {
    $fileTemplateState = {
      documentTemplateId: undefined,
      documentTempName: "None",
      baseImageUploadModal: false,
      runWatcher: false,
      baseImageInfo: {},
      fonts: [],
      activeFontFamily: "Arial",
      operations: [],
      download: false,
      canvasScale: 0,
      canvasHeight: 0,
      parsedJson: {},
      templateDel: false,
      apiFonts: [],
      goBack: false,
      showImageSection: false,
      footerArray: ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"],
    }
    localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
  }
</script>

<div class="fixed inset-0 z-20 flex select-none flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="w-[500px]">
    <div class="w-full rounded-t-md bg-darkgray p-5">
      <div class="pb-6 text-center text-lg font-bold tracking-wide text-slate-100">Leave File Design Template Editor</div>
      <p class="pb-1 text-center text-base font-medium leading-relaxed text-gray-600">There are unsaved modifications. Would you like to save them and leave?</p>
    </div>
  </div>
  <div class="flex w-[500px] justify-evenly rounded-b-md bg-[#242424] px-5 py-3">
    <button on:click={() => ($fileTemplateState.goBack = false)} class="active:bg-green-g00 group flex h-9 w-1/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none">
      <span class="text-white">
        <i class="fa-solid fa-circle-xmark" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Cancel</span>
    </button>

    <button on:click={backToListPage} class="active:bg-green-g00 group flex h-9 w-1/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none">
      <span class="text-white">
        <i class="fa-solid fa-ban" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Don't save</span>
    </button>
    <button disabled={disableSaveBtn} on:click={overAllTempSave} class="active:bg-green-g00 group flex h-9 w-1/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none">
      <span class="text-white">
        <i class="fa-solid fa-floppy-disk" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Save</span>
    </button>
  </div>
</div>
